var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h5',{domProps:{"innerHTML":_vm._s(_vm.header)}}),_c('h6',[_vm._v(" Account: "+_vm._s(_vm.account)),_c('br'),_vm._v(" Reference Number: "+_vm._s(_vm.reference)+" ")]),_c('div',{staticClass:"ExpansionLineTop mt-4"})])}
var staticRenderFns = []

export { render, staticRenderFns }